export default async function setupFacebook() {
  const urlsModule = await SystemJS.import('canopy-urls!sofe');
  const env = urlsModule.default.getEnvironment();

  if (
    (env === urlsModule.default.PRODUCTION_ENVIRONMENT ||
      env === urlsModule.default.STAGING_ENVIRONMENT ||
      env === urlsModule.default.INTEGRATION_ENVIRONMENT)
  ) {
    const facebookTracker = document.createElement('img');
    facebookTracker.src = "https://www.facebook.com/tr?id=1740818236239718&ev=PageView&noscript=1"
    facebookTracker.height = 1;
    facebookTracker.width = 1;
    facebookTracker.style.display = "none";

    document.body.appendChild(facebookTracker);
  }
}
